import * as React from "react";
import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path, Rect } from "react-native-svg";
import { getPrimaryColor } from "../../../src/utils/ColorsFunctions";
import { useAppSelector } from "../../../src/hooks/reduxHooks";

const BlogIcon = (props: { style?: StyleProp<ViewStyle> }) => {
	const user = useAppSelector((s) => s.auth.subUser!);

  return (
    <Svg width="22" height="24" fill="none" viewBox="0 0 22 24" {...props}>
      <Rect
        x="1"
        y="1"
        width="20"
        height="22"
        rx="3"
        strokeWidth="2"
        stroke={getPrimaryColor(user)}
      />
      <Path
        d="M6 8H16"
        stroke={getPrimaryColor(user)}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M6 12H16"
        stroke={getPrimaryColor(user)}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M6 16H16"
        stroke={getPrimaryColor(user)}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  );
};
export default BlogIcon;
